var eurowater = eurowater || {};
eurowater.swiperSlider = {
    init: function () {
        if ( jQuery( '.js-swiper-slider' ).length > 0 ) {
            eurowater.swiperSlider.bindEvents();
        }
    },
    bindEvents: function () {
        const swiper = new Swiper('.swiper', {
            direction: 'horizontal',
            loop: true,
            
            autoplay: {
                delay: 1
                //disableOnInteraction: true,
                //pauseOnMouseEnter: true
            },
            allowTouchMove: false,
            freeMode: false,
            freeModeMomentum: false,
            speed: 5000,
            slidesPerView: 6,
            //slidesPerGroup: 2,
            spaceBetween: 100,
            grabCursor: false,
            mousewheelControl: false,
            keyboardControl: false,
            breakpoints: {
                320: {
                    slidesPerView: 3,
                    spaceBetween: 5,
                },
                640: {
                    slidesPerView: 4,
                    spaceBetween: 10
                },
                1050: {
                    slidesPerView: 5,
                    spaceBetween: 30
                },
            }
        });

    }
};
